import { render, staticRenderFns } from "./wtEllipsisAnimation.component.vue?vue&type=template&id=4f7e393f&scoped=true&"
import script from "./wtEllipsisAnimation.component.vue?vue&type=script&lang=js&"
export * from "./wtEllipsisAnimation.component.vue?vue&type=script&lang=js&"
import style0 from "./wtEllipsisAnimation.component.vue?vue&type=style&index=0&id=4f7e393f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f7e393f",
  null
  
)

export default component.exports